export const programTemplateSiteCoreKeys = {
  header: "MasterDataManagement.SearchClientComponent.SearchClientHeader",
  headerNewProgramTemplate: "MasterDataManagement.SearchProgramTemplateHeader",
  headerNewProgramTemplateLabel:
    "SearchProgramTemplateHeader.NewProgramTemplate",
  searchFormKey: "MasterDataManagement.ProgramTemplateSearchSection",
  programTemplateNameLabel: "ProgramTemplateSearchSection.ProgramTemplateName",
  lineOfBusinessLabel: "ProgramTemplateSearchSection.LineOfBusiness",
  productLineLabel: "ProgramTemplateSearchSection.ProductLine",
  programFrameworkLabel: "ProgramTemplateSearchSection.ProgramFramework",
  statusLabel: "ProgramTemplateSearchSection.Status",
  countryLabel: "ProgramTemplateSearchSection.Country",
  result: "MasterDataManagement.ProgramTemplateResultsSection",
  programTemplateNameHeader: "ProgramTemplateSearchSection.ProgramTemplateName",
  programFrameworkHeader: "ProgramTemplateSearchSection.ProgramFramework",
  solutionCategoryHeader: "ProgramTemplateSearchSection.SolutionCategory",
  solutionSubCategory: "ProgramTemplateSearchSection.SolutionSub-Category",
  countryHeader: "ProgramTemplateSearchSection.Country",
  filterByList: "ProgramTemplateSearchSection.FilterByList",
  contains: "FilterBy.Contains",
  statusList: "ProgramTemplateSearchSection.StatusList",
  activitiesList: "ActivitiesList",
  activityTabText: "ActivitiesList.ActivitiesTabText",
  deliverablesTabText: "ActivitiesList.DeliverablesTabText",
};
